import {IBackendCaller} from "./backendCaller";

const printableCalendarDefaultUrl = "/api/eventsCalendar";

export interface IPrintableCalenderService {
  downloadPrintableCalender(
    filename: string,
    month: string,
    villageId: string,
    calendarName: string,
    sectionName?: string
  ): Promise<void>;
}

export class PrintableCalendarService implements IPrintableCalenderService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  downloadPrintableCalender(
    filename: string,
    month: string,
    villageId: string,
    calendarName: string,
    sectionName?: string
  ) {
    let url = `${printableCalendarDefaultUrl}?villageId=${villageId}&month=${month}&calendarName=${calendarName}`;

    if (sectionName) {
      url = `${url}&sectionName=${sectionName}`;
    }

    return this.backendCaller.downloadFile(filename, "GET", url, null);
  }
}
